import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

interface IState {
  text: string;
  openCircle?: boolean;
}

const initialState: IState = { text: "", openCircle: false };

export const tooltipSlice = createSlice({
  name: "tooltip",
  initialState,
  reducers: {
    setTooltip: (state, action: PayloadAction<IState>) => {
      return { ...state, ...action.payload };
    },
    changeCircle: (state, action: PayloadAction<boolean>) => {
      return { ...state, openCircle: action.payload };
    },
  },
});

export const { setTooltip, changeCircle } = tooltipSlice.actions;

export default tooltipSlice.reducer;
